"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _APButton = _interopRequireDefault(require("../../common/APButton"));
var _cssClassesHelper = require("../../../helpers/cssClassesHelper");
require("./ActivityReportingButtonsComponent.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var activityReportingButtonsClasses = (0, _cssClassesHelper.getBEMClasses)(['activity-reporting-buttons']);
var REPORT_TABS = {
  SINGLE: 0,
  CYCLICAL: 1
};
var ActivityReportingButtonsComponent = function ActivityReportingButtonsComponent(_ref) {
  var openReportsSidePane = _ref.openReportsSidePane;
  var _useTranslation = (0, _reactI18next.useTranslation)('activity'),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_APButton["default"], {
    type: "submit",
    onClick: function onClick() {
      return openReportsSidePane({
        index: REPORT_TABS.SINGLE
      });
    },
    customClass: activityReportingButtonsClasses()
  }, t('Single Report')), /*#__PURE__*/_react["default"].createElement(_APButton["default"], {
    type: "submit",
    onClick: function onClick() {
      return openReportsSidePane({
        index: REPORT_TABS.CYCLICAL
      });
    },
    customClass: activityReportingButtonsClasses()
  }, t('Cyclical Report')));
};
var _default = exports["default"] = ActivityReportingButtonsComponent;